<template>
    <div>
      <trademark-note-type-list></trademark-note-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  